<template>
  <div class="port-slot-pill" :class="{ 'is-free': !slot.equipmentName }">
    <span class="port-position">{{ slot.position }}</span>
    <span class="port-name">{{ slot.equipmentName || "livre" }}</span>
  </div>
</template>

<script>
export default {
  name: "PortSlotPill",
  props: {
    slot: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.port-slot-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 16px;
  background-color: var(--green-3v3, #3d9161);
  color: white;
  font-size: 0.85em;
  white-space: nowrap;
}

.port-slot-pill.is-free {
  background-color: #e8e8e8;
  color: #8a8a8a;
}

.port-position {
  font-weight: bold;
  opacity: 0.85;
}

.port-name {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
